/**
 * Request-aware fetch wrapper that talks to the BFF proxy (/api/v1/*).
 * Optionally attaches a share token header for anonymous list access.
 */
export function useApi() {
    const shareToken = useState<string | null>('share-token', () => null)
    const guestName = useState<string | null>('api-guest-name', () => null)
    const requestFetch = useRequestFetch()

    function headers(): Record<string, string> {
        const h: Record<string, string> = {}
        if (shareToken.value) h['X-Share-Token'] = shareToken.value
        if (guestName.value) h['X-Guest-Name'] = guestName.value
        return h
    }

    async function get<T>(path: string, query: Record<string, unknown> = {}): Promise<T> {
        return await requestFetch<T>(`/api/v1${path}`, { query, headers: headers() })
    }

    async function post<T>(path: string, body: Record<string, unknown> = {}): Promise<T> {
        return await requestFetch<T>(`/api/v1${path}`, { method: 'POST', body, headers: headers() })
    }

    async function patch<T>(path: string, body: Record<string, unknown> = {}): Promise<T> {
        return await requestFetch<T>(`/api/v1${path}`, {
            method: 'PATCH',
            body,
            headers: headers(),
        })
    }

    async function destroy<T>(path: string, body: Record<string, unknown> = {}): Promise<T> {
        return await requestFetch<T>(`/api/v1${path}`, {
            method: 'DELETE',
            body,
            headers: headers(),
        })
    }

    return { get, post, patch, destroy, shareToken, guestName }
}
